const snakeCaseToCamelCase = (stringToCamelCase: string) =>
  stringToCamelCase
    .split(/[_|-]/)
    .map((word, index) => {
      if (index === 0) return word;
      return word[0].toUpperCase() + word.substring(1);
    })
    .join('');

export default snakeCaseToCamelCase;
